<script>
import { Link } from "@inertiajs/vue3";
import TopicForm from './_form.vue';
import Ajax from '@vvg/forum/js/mixins/ajax.js';
import Scroll from '@vvg/forum/js/mixins/scroll.js';

export default {
  components: { TopicForm, Link },
  mixins: [Ajax, Scroll],
  props: {
    forum: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$nextTick(() => this.scrollToForum());
  },
  methods: {
    submit() {
      this.submitForm(
          this.$page.props.forum_url + 'save_topics/',
          'POST',
          this.$refs.form.form
      ).done(() => {
        this.showToast('Onderwerp aangemaakt!');
        this.$inertia.visit(this.$page.props.forum_url + this.$props.forum.id + '/onderwerpen/');
      });
    }
  }
}
</script>

<template>
  <div class="container-xl py-4">

    <div class="d-flex justify-content-between align-items-start mb-4">
      <div>
        <nav class="topic-breadcrumb mb-2" aria-label="Navigatie">
          <Link :href="$page.props.forum_url" class="topic-breadcrumb__link">Forum</Link>
          <i class="fa fa-chevron-right topic-breadcrumb__sep"></i>
          <Link :href="$page.props.forum_url + forum.id + '/onderwerpen/'" class="topic-breadcrumb__link">
            {{ forum.title }}
          </Link>
          <i class="fa fa-chevron-right topic-breadcrumb__sep"></i>
          <span class="text-muted">Onderwerpen</span>
        </nav>
        <h1 class="topic-page-title mb-0">Onderwerp toevoegen</h1>
      </div>
      <Link
          :href="$page.props.forum_url + forum.id + '/onderwerpen/'"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2 mt-1"
      >
        <i class="fa fa-arrow-left"></i> Terug
      </Link>
    </div>

    <div class="topic-form-card">
      <form id="topic-create-form" @submit.prevent="submit">
        <div class="topic-form-card__body">
          <TopicForm ref="form" :forum="forum" />
        </div>
      </form>
    </div>

    <div class="topic-form-footer">
      <Link
          :href="$page.props.forum_url + forum.id + '/onderwerpen/'"
          class="btn btn-outline-secondary btn-sm"
      >
        Annuleren
      </Link>
      <button type="submit" form="topic-create-form" class="btn btn-dark btn-sm d-flex align-items-center gap-2">
        <i class="fa fa-check"></i> Opslaan
      </button>
    </div>
  </div>
</template>